import { render, staticRenderFns } from "./AmThucForm.vue?vue&type=template&id=0c84b84c"
import script from "./AmThucForm.vue?vue&type=script&lang=js"
export * from "./AmThucForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports